import { z } from 'zod';

import { makeFieldSchemaFromZod } from '../utils';

export const KubernetesClusterPickerFieldSchema = makeFieldSchemaFromZod(
  z.string().or(z.object({})),
  z.object({
    onlyUserOwned: z
      .boolean()
      .default(false)
      .describe('Return only Clusters that are owned by the user'),
  }),
);

/**
 * Schema for the KubernetesClusterPicker.
 * @public
 */
export const KubernetesClusterPickerSchema =
  KubernetesClusterPickerFieldSchema.schema;
